<template>
  <section>
    <!-- Lista de Eventos -->
    <v-row justify="start">
      <v-col cols="12" md="10" v-for="(event, index) in events" :key="index" class="event-wrapper">
        <div class="event-container" @click="!event.preferencial_date_start ? editEvent(event) : null">
          <!-- Cartão do evento -->
          <v-card flat :class="['event-card', getCardClass(event)]">
            <div class="event-content">
              <p class="event-title">
                <v-row>
                  <v-col cols="7" md="8" align="start">
                    <strong :style="{ paddingLeft: '20px' }" class="d-none d-md-block">{{ limitTitle(event.title) }}</strong>
                    <strong :style="{ paddingLeft: '15px', fontSize: '14px' }" class="d-md-none d-block">{{ limitTitleMobile(event.title) }}</strong>
                  </v-col>
                  <v-col cols="5" md="4" align="end">
                    <span class="participants d-none d-md-block">{{ event.n_participants || 0 }} participantes</span>
                    <span class="participants d-md-none d-block" :style="{ paddingRight: '15px', fontSize: '14px' }">{{ event.n_participants || 0 }} 
                      <v-icon>mdi-account</v-icon>
                    </span>
                  </v-col>
                </v-row>
              </p>
              <p v-if="!event.preferencial_date_start" class="event-description">{{ truncateText(event.description, 120) }}</p>
            </div>
            <v-row no-gutters v-if="event.preferencial_date_start && !isMobile" @click.stop="confirmReopenEvent(event.id)">
              <v-col cols="12" align="center">
                Data fechada
              </v-col>
              <v-col v-if="event.duration_type !== 'hours'" cols="12" align="center">
                {{ formatDate(event.preferencial_date_start) }} - {{ formatDate(event.preferencial_date_end) }}
              </v-col>
              <v-col v-else cols="12" align="center">
                {{ formatEventHours(event.preferencial_date_start, event.preferencial_date_end) }}
              </v-col>
            </v-row>
            <v-row no-gutters v-if="event.preferencial_date_start && isMobile" @click.stop="confirmReopenEvent(event.id)" style="font-size: 14px;">
              <v-col cols="12" align="center">
                Data fechada
              </v-col>
              <v-col v-if="event.duration_type !== 'hours'" cols="12" align="center">
                {{ formatDate(event.preferencial_date_start) }} - {{ formatDate(event.preferencial_date_end) }}
              </v-col>
              <v-col v-else cols="12" align="center">
                {{ formatEventHours(event.preferencial_date_start, event.preferencial_date_end) }}
              </v-col>
            </v-row>

          </v-card>

         <!-- Botão de Apagar -->
         <v-btn icon class="delete-btn" @click.stop="confirmDeleteEvent(event.id)" style="color: black; opacity: 0.5">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <DialogConfirmation
      v-if="dialogVisible"
      v-model="dialogVisible"
      type="warning"
      @on-cancel="closeDialog"
      @on-submit="proceedDeleteEvent"
    >
      Tem certeza que deseja sair deste evento?
    </DialogConfirmation>

    <DialogConfirmation
      v-if="dialogReopenVisible"
      v-model="dialogReopenVisible"
      type="warning"
      @on-cancel="closeReopenDialog"
      @on-submit="proceedReopenEvent"
    >
      Deseja reativar este evento?
    </DialogConfirmation>


    <!-- ISTO SO APARECE SE FOR MOBILE. A CLASS d-sm-none FAZ COM QUE SO APAREÇA EM MOBILE -->
    <div class="d-sm-none mobile-padding"></div>
  </section>
</template>
  
  <script>
  import Events from '@/api/Events.js';
  import DialogConfirmation from '@/components/ui/DialogConfirmation.vue';

  export default {
    components: {
      DialogConfirmation
    },

    props: {
      events: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        confirmDelete: null, 
        dialogVisible: false,
        confirmReopen: null,
        dialogReopenVisible: false
      };
    },
    computed:{      
      isMobile() {
        return window.innerWidth <= 1460;
      },
    },
    methods: {

      formatEventHours(startStr, endStr) {
          const start = new Date(startStr);
          const end = new Date(endStr);

          const day = String(start.getDate()).padStart(2, '0');
          const month = String(start.getMonth() + 1).padStart(2, '0');
          const year = start.getFullYear();

          const startHour = String(start.getHours()).padStart(2, '0');
          const startMin = String(start.getMinutes()).padStart(2, '0');
          const endHour = String(end.getHours()).padStart(2, '0');
          const endMin = String(end.getMinutes()).padStart(2, '0');

          return `${day}/${month}/${year} ${startHour}:${startMin} - ${endHour}:${endMin}`;
        },
      truncateText(text, maxLength = 100) {
        if (!text) return '';
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
      },

      limitTitle(text) {
          const maxLength = 30; // Define o limite máximo de caracteres para truncar
          if (!text) return ''; // Se não houver texto, retorna uma string vazia
          return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
      },

      limitTitleMobile(text) {
          const maxLength = 12; // Define o limite máximo de caracteres para truncar
          if (!text) return ''; // Se não houver texto, retorna uma string vazia
          return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
      },

      getCardClass(event) {
          if (event.preferencial_date_start) {
              return 'transparent-card';
          } else if (event.allAgree) {
              return 'green-card';
          } else {
              return 'closed-card';
          }
      },
      editEvent(event) {
          this.$emit('editEvent', event);
      },
      
    // Abre o modal de confirm
    confirmDeleteEvent(eventId) {
      this.confirmDelete = eventId;
      this.dialogVisible = true;
    },

    // Fecha o modal sem apagar o evento
    closeDialog() {
      this.dialogVisible = false;
      this.confirmDelete = null;
    },

    confirmReopenEvent(eventId) {
      this.confirmReopen = eventId;
      this.dialogReopenVisible = true;
    },

    closeReopenDialog() {
      this.dialogReopenVisible = false;
      this.confirmReopen = null;
    },

 
    // Apaga o evento se for confirmado
    async proceedDeleteEvent() {
      if (!this.confirmDelete) return;

      try {
        await Events.delete(this.confirmDelete);
        this.$emit('eventDeleted');
      } catch (error) {
        console.error('Erro ao apagar evento:', error);
      }

      this.closeDialog();
    },

    async proceedReopenEvent() {
      try {
        await Events.reopen(this.confirmReopen);
        this.$emit('eventDeleted')
        this.closeReopenDialog();
      } catch (error) {
        console.log("Erro ao reabrir evento:", error.response?.data || error);
      }
    },
    }
  };
  </script>
  
  <style scoped>

@media (max-width: 600px) {
    .mobile-padding{
        padding-bottom: 100px; /* Aumenta o espaço apenas no mobile */
    }

    .event-card {
        height: 110px !important; /* Permite que a altura ajuste conforme o conteúdo no mobile */
    }

    .event-description {
        -webkit-line-clamp: 3; /* Mostra até 3 linhas no mobile */
        line-clamp: 3;
        font-size: 13px;
        padding-right: 15px;
        padding-left: 15px;
    }

    .v-application p {
      margin-bottom: 0;
    }
    
}
    .event-wrapper {
        margin-bottom: 20px;
    }

    .event-container {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .event-card {
        flex: 1;
        border-radius: 50px;
        height: 130px; /* Definir uma altura fixa para os cards */
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .event-content {
        padding: 16px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    .event-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .event-description {
      flex-grow: 1;
      max-height: 90px; /* Define um limite de altura */
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* Exibe no máximo 2 linhas antes de cortar */
      line-clamp: 2; /* Exibe no máximo 2 linhas antes de cortar */
      -webkit-box-orient: vertical;
      white-space: normal;
      position: relative;
    }


    .participants {
        font-size: 0.9em;
        color: gray;
    }

    .closed-date {
        color: rgb(0, 0, 0);
        text-align: center;
    }

    .delete-btn {
        margin-left: 10px;
    }

    .closed-card {
        background-color: rgba(255, 255, 255, 0.4); /* Opaco */
    }

    .green-card {
        background-color: #cbd8c7; 
    }

    .transparent-card {
        background-color: transparent;
        border: 1px solid #000000;
    }
    
  </style>